module.exports = __webpack_public_path__ + "img/PHP-logo.ef31daa6.svg";